module.exports = __webpack_public_path__ + "static/media/logo_forbes.75734f35.svg";